import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import { formatLocal, formatUTC } from 'utils/date'
import Pagination from '@mui/material/Pagination'

import { translate } from 'locales'

import { CardDate } from 'components'
import noData from 'assets/images/no-data.svg'
import TimeLineResume from './TimeLineResume'

import * as S from './styles'
import * as N from '../New/styles'
import {
  Timeline,
  TimelineContent,
  TimelineOppositeContent,
  AccordionHeadingDivResponsive,
} from '../timelineStyles'

const Resume = ({ medicalRecords, count, setPage }: any) => {
  return (
    <>
      <Timeline position="right">
        {medicalRecords && Object.keys(medicalRecords).length === 0 && (
          <N.NoData>
            <img
              src={noData}
              alt="Icone simbolizando que não existe prontuarios a serem exibidas"
            />
            <span>{translate('medicalRecord.notMedicalRecord')}</span>
          </N.NoData>
        )}

        {medicalRecords &&
          Object.keys(medicalRecords)
            .reverse()
            ?.map((item) => (
              <TimelineItem key={item}>
                <TimelineOppositeContent>
                  <CardDate
                    day={formatUTC(item, 'dd')}
                    month={formatUTC(item, 'MMM')}
                    year={formatUTC(item, 'yyyy')}
                  />
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  {medicalRecords[item].map((i: any) => (
                    <Accordion key={i.uuid}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id={i.uuid}
                      >
                        <AccordionHeadingDivResponsive
                          style={{
                            marginTop: 0,
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <Typography>
                            {`${translate('medicalRecord.by')} Dr(a). ${
                              i?.scheduling?.doctor?.name
                            }`}
                            <Typography>
                              {`${translate('schedule.scheduleDate')}: ${formatLocal(i.scheduling.from_date_time, 'dd/MM/yyyy')}`}
                            </Typography>
                          </Typography>
                        </AccordionHeadingDivResponsive>
                        <div>
                          <Typography>
                            {`(${i.scheduling?.specialty_name})`}
                          </Typography>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{ display: 'block', padding: 0 }}
                      >
                        <TimeLineResume
                          history={i}
                          prescriptions={i.scheduling?.prescriptions}
                        />
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </TimelineContent>
              </TimelineItem>
            ))}

        <S.ContentPagination>
          {count > 1 && <Pagination count={count} onChange={setPage} />}
        </S.ContentPagination>
      </Timeline>
    </>
  )
}

export default Resume
